export type MasterTag = {
  name: string;
  url: string;
  product: number[];
  country?: string[];
  disabledCountry?: string[];
  commodity?: number[];
  disableCommodies?: number[];
  enabledTime?: number;
  deadline?: number;
  scaleProductMaster?: boolean;
} & ({ width?: number; specialWidth?: never } | { width?: never; specialWidth?: number }) &
  ({ height?: number; specialHeight?: never } | { height?: never; specialHeight?: number });

/**
 * 获取TopSide 产品主图上的标签图片信息
 * 为了减少CLS可以把height带上。
 * import { getTag } from '@/pages/product/config/DisplayTag.config';
 * 商城-奖章Logo处理逻辑梳理文档:https://arashivision.feishu.cn/docx/ZZj3d1dzGoEDelxVW9ccAdsqnKg?
 */
const TAG_CONFIG = (isMobile: boolean): Array<MasterTag> => {
  return [
    {
      name: 'x4_awardFR',
      url: 'https://res.insta360.com/static/4106a11ff61f8c34bf22910533f09d42/img_v3_02cg_fbeb34d8-9092-44a8-995d-5a20155e428g%201.png',
      product: [26],
      country: ['FR'],
      commodity: [
        2994, 2997, 2995, 3001, 3002, 3004, 2998, 2996, 3003, 2999, 3000, 3005, 3008, 3006, 3012, 3013, 3015, 3009,
        3007, 3014, 3010, 3011,
      ],
      deadline: 1766764799000, // 下线时间 2025/12/26 23:59:59
      specialHeight: isMobile ? 40 : 55,
      specialWidth: isMobile ? 58 : 80,
      scaleProductMaster: true,
    },
    {
      name: 'AcePro_awardsEN',
      product: [25],
      url: 'https://res.insta360.com/static/4c08257b4d96c5186008df7fbed8abb2/2024_Award%20logos_INSTA360%202.png',
      country: [
        'US',
        'CA',
        'BR',
        'IL',
        'AE',
        'SA',
        'KW',
        'IN',
        'GB',
        'CH',
        'SE',
        'SI',
        'SK',
        'RO',
        'PT',
        'PL',
        'NO',
        'NL',
        'MC',
        'MT',
        'LU',
        'LT',
        'LI',
        'LV',
        'IE',
        'IS',
        'HU',
        'GR',
        'FI',
        'EE',
        'DK',
        'CZ',
        'CY',
        'HR',
        'BG',
        'BE',
        'RU',
        'VN',
        'TH',
        'SG',
        'PH',
        'NZ',
        'MY',
        'ID',
        'HK',
        'BN',
        'AU',
      ],
      deadline: 1751471999000, // 下线时间 2025/07/02 23:59:59
      commodity: [2641, 2688, 2694, 2693, 2692, 2689, 2691, 2690, 3329, 3330],
      specialHeight: isMobile ? 68 : 95,
      specialWidth: isMobile ? 48 : 68,
      scaleProductMaster: true,
    },
    {
      name: 'AcePro_cnetKorea',
      product: [25],
      url: 'https://res.insta360.com/static/3a95030fab21b0c6cc1678944202a986/Group%20626873615%20(1).png',
      country: ['KR'],
      commodity: [2641, 2688, 2694, 2693, 2692, 2689, 2691, 2690],
      width: isMobile ? 44 : 60,
    },
    {
      name: 'jp_2024_gold_award_mobile',
      url: 'https://res.insta360.com/static/4df237fe9156f4cfa6c3f1ae3aae3843/24moblie%E7%BB%BC%E5%90%88%E9%87%91%E8%B5%8F-240.png',
      product: [22],
      country: ['JP'],
      enabledTime: 1711692000000, // 上线时间 2024/03/29 14:00:00
      deadline: 1730390399000, // 下线时间 2024/10/31 23:59:59
      width: isMobile ? 60 : 80,
    },
    {
      name: 'jp_annual_award',
      url: 'https://res.insta360.com/static/259fbcef367faabb632bc0f5ee06117b/23%E5%B9%B4%E5%BA%A6%E5%8F%97%E8%B5%8F-240.png',
      product: [19, 22],
      country: ['JP'],
      deadline: 1730390399000, // 下线时间 2024/10/31 23:59:59
      width: isMobile ? 60 : 80,
    },
    {
      name: 'jp_total_gold_award',
      url: 'https://res.insta360.com/static/d2515ade9407ad5d9fed38377c61b835/23moblie%E7%BB%BC%E5%90%88%E9%87%91%E8%B5%8F-240.png',
      product: [22],
      country: ['JP'],
      deadline: 1730390399000, // 下线时间 2024/10/31 23:59:59
      width: isMobile ? 60 : 80,
    },
    {
      name: 'jp_2023_gold_award_mobile',
      url: 'https://res.insta360.com/static/146fd5874ec2cc2b9a9126fabd5accf8/23moblie%E9%87%91%E8%B5%8F-240.png',
      product: [22],
      country: ['JP'],
      deadline: 1711692000000, // 下线时间 2024/03/29 14:00:00
      width: isMobile ? 60 : 80,
    },
    {
      name: 'jp_2023_gold_award_imaging',
      url: 'https://res.insta360.com/static/e059eb5aed9bd539c7c21d87ccb83600/23imaging%E9%87%91%E8%B5%8F-240.png',
      product: [19, 24],
      country: ['JP'],
      deadline: 1729868400000, // 下线时间 2024/10/25 23:00:00
      width: isMobile ? 60 : 80,
    },
    {
      name: 'tom_hardware',
      url: 'https://res.insta360.com/static/infr_base/5ba36f8faba552a7f43c0e53f1e4e0a0/image%207.png',
      product: [15],
      country: ['IT'],
      width: isMobile ? 56 : 90,
    },
    {
      name: 'bestBuy',
      url: 'https://res.insta360.com/static/e0d9755cd61cbf40f6c59c7d3bf72120/bestBuy.png',
      disabledCountry: ['CN'],
      product: [14],
      width: isMobile ? 56 : 72,
    },
    {
      name: 'badge_img_wired',
      url: 'https://static.insta360.com/assets/storage/20200508/640798782fb5efcfd6b96f891210a43e/badge_img_wired.svg',
      country: ['US', 'AU', 'CA', 'GB'],
      product: [12],
      width: isMobile ? 56 : 72,
    },
    {
      name: 'chip',
      url: 'https://res.insta360.com/static/assets/storage/20200721/f03399f801dbf10c088f3e86a56495be/tag.jpg',
      country: [], // 20210722已下线
      product: [12],
      commodity: [1106, 1001, 972, 974, 1104, 1000, 1066, 1092, 1105, 1122, 1123, 1013, 1209, 1139, 973],
      width: isMobile ? 48 : 64,
    },
    {
      name: 'fotohits',
      url: 'https://res.insta360.com/static/assets/storage/20210519/ac5743bda0095d70f188a2b471a3fb12/fotohits_onex2.jpg',
      country: ['DE', 'AT', 'CH'],
      product: [13],
      width: isMobile ? 69 : 85,
    },
    {
      name: 'fotohits_1inch',
      url: 'https://res.insta360.com/static/infr_base/7179f78a59f550a816a4de37b87827aa/DE_logo.jpg',
      country: ['DE', 'AT', 'CH'],
      product: [17],
      width: isMobile ? 69 : 85,
    },
    {
      name: 'avfb',
      url: 'https://res.insta360.com/static/assets/storage/20210601/8d4b550c49c020529f64b5834be8ce50/AVFB.jpg',
      country: ['DE'],
      product: [14],
      width: isMobile ? 56 : 72,
    },
    {
      name: 'gear',
      url: 'https://res.insta360.com/static/d80b1c35977940c7042146c230921c19/GO_2_%E9%AA%91%E8%A1%8C%E8%AE%A4%E8%AF%81logo.png',
      country: ['US', 'CA'],
      product: [14],
      width: isMobile ? 64 : 80,
    },
    {
      name: 'mtc',
      url: 'https://res.insta360.com/static/dbdaec827706771febab050e4efbaa9a/20230314-165448.png',
      disabledCountry: ['CN', 'JP'],
      deadline: 1732982400000, // 下线时间 2024/12/1
      product: [13, 15],
      commodity: [1181, 1745, 2183],
      width: isMobile ? 56 : 84,
    },
    {
      name: 'jp-mtc',
      url: 'https://res.insta360.com/static/9c93270cc43963facd8c0f3466671144/kawasaki.png',
      country: ['JP'],
      deadline: 1732982400000, // 下线时间 2024/12/1
      product: [13, 15],
      commodity: [1181, 1745, 2183],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'x3_mtc',
      url: 'https://res.insta360.com/static/dbdaec827706771febab050e4efbaa9a/20230314-165448.png',
      disabledCountry: ['CN', 'JP'],
      deadline: 1732982400000, // 下线时间 2024/12/1
      product: [19],
      commodity: [2105, 2226, 2211],
      width: isMobile ? 56 : 84,
    },
    {
      name: 'jp-x3_mtc',
      url: 'https://res.insta360.com/static/9c93270cc43963facd8c0f3466671144/kawasaki.png',
      country: ['JP'],
      deadline: 1732982400000, // 下线时间 2024/12/1
      product: [19],
      commodity: [2105, 2226, 2211],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'computer_15',
      url: 'https://res.insta360.com/static/bd2eac0fdcd31d289884904cf28b7365/Insta360OneRS_GUT_CBde_25112022%201.png',
      country: ['CH', 'AT', 'DE'],
      deadline: 1701273600000, // 下线时间 2023/11/30
      product: [15],
      commodity: [1742, 1962, 1743, 1744, 1745, 1746],
      width: isMobile ? 45 : 73,
    },
    // {
    //   name: 't3',
    //   url: 'https://res.insta360.com/static/infr_base/387a1ab875f1223bc62e21b5eca015be/logo_t3.png',
    //   disabledCountry: ['CN', 'RU'],
    //   product: [13, 15],
    //   width: isMobile ? 56 : 72,
    // },
    {
      name: 'jp-GOOD-DESIGN-AWARD-rs',
      url: 'https://res.insta360.com/static/77ae05450a614a4b435dd61775c949c6/22%E5%B9%B4%E5%BA%A6%E5%8F%97%E8%B5%8F-240.png',
      country: ['JP'],
      product: [17, 18],
      deadline: 1729868400000, // 下线时间 2024/10/25 23:00:00
      width: isMobile ? 60 : 80,
    },

    {
      name: 'jp-GOOD-DESIGN-AWARD-rs',
      url: 'https://res.insta360.com/static/77ae05450a614a4b435dd61775c949c6/22%E5%B9%B4%E5%BA%A6%E5%8F%97%E8%B5%8F-240.png',
      country: ['JP'],
      product: [15],
      deadline: 1729868400000, // 下线时间 2024/10/25 23:00:00
      commodity: [1742, 1743, 2597, 2183, 1746, 2350, 1962, 2351, 2355, 2182, 2184, 1744, 1745],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'techradar',
      url: 'https://res.insta360.com/static/ff9acde3de7f674c43fc0b5ebd406547/img_v2_05a8350f-a8e8-4785-ac04-50824aab7ffg%201.png',
      disabledCountry: ['CN', 'RU', 'DE', 'AT', 'CH', 'JP'],
      product: [18],
      width: isMobile ? 49 : 70,
    },
    {
      name: 'techradar',
      url: 'https://res.insta360.com/static/54e1db2d36bbf4eff82eb061558a6857/tr.png',
      country: ['JP'],
      product: [18],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'computer_sehr_gut_link',
      url: 'https://res.insta360.com/static/fc68cd52634c4a65dcf8d012fff3e9ca/20221216-152526.jpeg',
      country: ['DE', 'AT', 'CH'],
      deadline: 1702483200000, // 下线时间 2023/12/14
      product: [18],
      width: isMobile ? 49 : 70,
    },
    {
      name: 'computer_19',
      url: 'https://res.insta360.com/static/86ffa2a885537edff4f2a4cdebff9e62/Insta360X3_GUT_CBde_25112022%201.png',
      country: ['CH', 'AT', 'DE'],
      deadline: 1701273600000, // 下线时间 2023/11/30
      product: [19],
      disableCommodies: [2358, 2359, 2360, 2361, 2362, 2363],
      width: isMobile ? 45 : 73,
    },
    {
      name: 'wired_oneRs',
      url: 'https://res.insta360.com/static/06f80ed7fb2881f997801b8f2f779bc0/cc2.png',
      country: ['US', 'GB', 'CA'],
      deadline: 1693497599000, // 下线时间 2023/8/31 23:59:59
      product: [15],
      width: isMobile ? 50 : 80,
    },
    {
      name: 'jp-dgp2022-x3',
      url: 'https://res.insta360.com/static/afe20304450ce42f6064540dbfb58834/22imaging%E7%BB%BC%E5%90%88%E9%87%91%E8%B5%8F-240.png',
      country: ['JP'],
      deadline: 1729868400000, // 下线时间 2024/10/25 23:00:00
      product: [19],
      disableCommodies: [2358, 2359, 2360, 2361, 2362, 2363],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'jp-dgp2022-gold-rs',
      url: 'https://res.insta360.com/static/0bb1feef65c160aadc0ab2112860b819/22imaging%E9%87%91%E8%B5%8F-240.png',
      country: ['JP'],
      deadline: 1729868400000, // 下线时间 2024/10/25 23:00:00
      product: [15],
      commodity: [1742, 1743, 2597, 2183, 1746, 2350, 1962, 2351, 2355, 2182, 2184, 1744, 1745],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'jp-dgp2022-gold-rs-1inch',
      url: 'https://res.insta360.com/static/0bb1feef65c160aadc0ab2112860b819/22imaging%E9%87%91%E8%B5%8F-240.png',
      country: ['JP'],
      deadline: 1729868400000, // 下线时间 2024/10/25 23:00:00
      product: [17],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'jp-dgp2022-imaging-rs-1inch',
      url: 'https://res.insta360.com/static/b3b70ebc8fa3ccfc2a9c324a05642eaf/22imaging%E6%8A%80%E6%9C%AF%E4%BC%81%E7%94%BB%E8%B5%8F-240.png',
      country: ['JP'],
      deadline: 1729868400000, // 下线时间 2024/10/25 23:00:00
      product: [17],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'zoom',
      url: 'https://res.insta360.com/static/d29295ddbe84bdfa752dcafe661ee0e2/zoom.png',
      disabledCountry: ['CN', 'JP'],
      product: [18],
      width: isMobile ? 50 : 70,
    },
    {
      name: 'zoom',
      url: 'https://res.insta360.com/static/2d970c87775efab679433b33020c3e14/zoom.png',
      country: ['JP'],
      product: [18],
      width: isMobile ? 60 : 80,
    },
    {
      name: 'trustedReviews',
      url: 'https://res.insta360.com/static/c2d32ee253fa9c5bb3d56a31aacfae13/logo.svg',
      country: ['US', 'CA'],
      deadline: 1721059200000, // 下线时间 2024/10/25 23:00:00
      product: [22],
      width: isMobile ? 60 : 80,
    },
    // https://arashivision.feishu.cn/wiki/PFB1wsX0iikXfHkUY48coKJgnCg?sheet=VnvAgB
    {
      name: 'AcePro-media-DE',
      url: 'https://res.insta360.com/static/11e3e92f636fc165229ee0026fe5732a/AcePro.png',
      country: ['DE', 'AT', 'CH'],
      product: [25],
      commodity: [2641, 2691, 2688, 2689, 2694, 3330, 2690, 2693, 3329, 2692],
      deadline: 1753027200000, // 下线时间 2025/07/21 00:00:00
      specialWidth: isMobile ? 58 : 100,
      specialHeight: isMobile ? 47.12 : 81.25,
    },
    // https://arashivision.feishu.cn/wiki/CHLYwO0paiqJMUkqo2vcBc0nnAf
    {
      name: 'X4-media-DE',
      url: 'https://res.insta360.com/static/10a63c09efd89f12657665873b4e38f6/x41%201.png',
      country: ['DE', 'AT', 'CH'],
      product: [26],
      commodity: [
        2994, 3001, 3375, 2997, 3377, 3395, 3397, 2995, 3002, 3004, 2998, 3393, 2996, 3003, 2999, 3000, 3005, 3012,
        3376, 3008, 3378, 3396, 3398, 3006, 3013, 3015, 3009, 3394, 3007, 3014, 3010, 3011, 3647, 3648,
      ],
      deadline: 1753027200000, // 下线时间 2025/07/21 00:00:00
      specialWidth: isMobile ? 45.92 : 80,
      specialHeight: isMobile ? 47.12 : 80,
      scaleProductMaster: true,
    },
    // https://arashivision.feishu.cn/wiki/L4QzweSj7id5fHkU38wc5FQvnad
    {
      name: 'GO3S-media-DE',
      url: 'https://res.insta360.com/static/f194aa08390466dfd481e4a9ed355bd0/GO3S.png',
      country: ['DE', 'AT', 'CH'],
      product: [27],
      commodity: [
        3120, 3121, 3122, 3123, 3130, 3131, 3132, 3133, 3125, 3126, 3127, 3128, 3135, 3136, 3137, 3138, 3469, 3470,
        3471, 3472, 3478, 3479, 3480, 3481,
      ],
      deadline: 1753977600000, // 下线时间 2025/08/01 00:00:00
      specialWidth: isMobile ? 58 : 100,
      specialHeight: isMobile ? 47.12 : 81.25,
    },
    // https://arashivision.feishu.cn/wiki/CHLYwO0paiqJMUkqo2vcBc0nnAf
    {
      name: 'X4-TIMEs-best-inventions-of-2024',
      url: 'https://res.insta360.com/static/5607bbc24556c9af4e958a9e64ba4416/1453.png',
      disabledCountry: ['DE', 'AT', 'CH', 'JP', 'FR'],
      product: [26],
      commodity: [
        2994, 3001, 3375, 2997, 3377, 3395, 3397, 2995, 3002, 3004, 2998, 3393, 2996, 3003, 2999, 3000, 3005, 3012,
        3376, 3008, 3378, 3396, 3398, 3006, 3013, 3015, 3009, 3394, 3007, 3014, 3010, 3011, 3647, 3648,
      ],
      deadline: 1751212800000, // 下线时间 2025/06/30 00:00:00
      specialWidth: isMobile ? 58 : 100,
      specialHeight: isMobile ? 57.52 : 99.17,
      scaleProductMaster: true,
    },
    // https://arashivision.feishu.cn/wiki/IUbYwJCaYiXXIhkuEXWcU7xLnQh
    {
      name: 'Link2-T3',
      url: 'https://res.insta360.com/static/f19a4b0616b2187b3e3916eaffbd558b/T3.png',
      disabledCountry: ['RU'],
      product: [29],
      commodity: [3401, 3402],
      specialWidth: isMobile ? 60 : 100,
      specialHeight: isMobile ? 61.25 : 102.08,
    },
    // https://arashivision.feishu.cn/wiki/IUbYwJCaYiXXIhkuEXWcU7xLnQh
    {
      name: 'Link2C-Toms-gudie',
      url: 'https://res.insta360.com/static/452d95b1ddca80f1b2af0a1fd0d074ed/logo%201.png',
      disabledCountry: ['RU'],
      product: [29],
      commodity: [3403, 3404],
      specialWidth: isMobile ? 58 : 75,
      specialHeight: isMobile ? 47.12 : 71.74,
    },
    {
      name: 'X4-JP',
      url: 'https://res.insta360.com/static/e44660746496db7a0e0d04abe8095cbb/20241114-111915%201.png',
      country: ['JP'],
      product: [26],
      commodity: [
        2994, 3001, 3375, 2997, 3377, 3395, 3397, 2995, 3002, 3004, 2998, 3393, 2996, 3003, 2999, 3000, 3005, 3012,
        3376, 3008, 3378, 3396, 3398, 3006, 3013, 3015, 3009, 3394, 3007, 3014, 3010, 3011, 3647, 3648,
      ],
      deadline: 1751817600000, // 下线时间 2025/07/07 00:00:00
      specialWidth: isMobile ? 55 : 91.67,
      specialHeight: isMobile ? 53.68 : 89.47,
      scaleProductMaster: true,
    },
    {
      name: 'Connect-AVTech',
      url: 'https://res.insta360.com/static/e0cfc44cbbba32c54a22bc6851bee62a/1454.png',
      product: [31],
      commodity: [3519, 3706, 3707],
      deadline: 1756656000000, // 下线时间 2025/09/01 00:00:00
      specialWidth: isMobile ? 58 : 100,
      specialHeight: isMobile ? 58 : 100,
    },
    {
      // https://arashivision.feishu.cn/wiki/PFB1wsX0iikXfHkUY48coKJgnCg?sheet=fPh290
      name: 'ActionCams',
      url: 'https://res.insta360.com/static/9d841f19231cd281309dc9a423dff885/AP2_Actioncams_CD166805.jpg',
      country: ['DE', 'AT', 'CH'],
      product: [30],
      commodity: [3611, 3612, 3613, 3614, 3615, 3616, 3617, 3618, 3619, 3621, 3622, 3623, 3624, 3625, 3626, 3883, 3882],
      deadline: 1756656000000, // 下线时间 2026/1/14
      specialWidth: isMobile ? 36 : 60,
      specialHeight: isMobile ? 38 : 64,
    },
  ];
};

export const getTag = ({
  pid,
  cid,
  country,
  isMobile,
}: {
  pid: number;
  cid: number;
  country: TBasicCountryInfo;
  isMobile: boolean;
}) => {
  const now = new Date().getTime();
  const tags = TAG_CONFIG(isMobile)
    .map((o) => {
      if (o.disabledCountry && o.disabledCountry.includes(country.code)) return null;
      if (o.product && !o.product.includes(pid)) return null;
      if (o.deadline && now >= o.deadline) return null;
      if (o.enabledTime && now < o.enabledTime) return null;
      if (!o.country || (o.country && o.country.includes(country.code))) return o;
      return null;
    })
    .filter((o) => !!o)
    .map((o) => {
      if (!o.commodity) return o;
      if (o.commodity && cid) return o.commodity.includes(cid) ? o : null;
      return null;
    })
    .filter((o) => !!o)
    .map((o) => {
      if (!o?.disableCommodies) return o;
      if (o?.disableCommodies?.includes(cid)) return null;
      return o;
    })
    .filter((o) => !!o);
  return tags;
};

export default { getTag };
